import sanitizeHtml from "sanitize-html";

const setHtml = (html = "") => {
  // Handle null/undefined values
  if (html == null) {
    html = "";
  }
  // Break long URLs by inserting word break opportunities
  const urlRegex = /(https?:\/\/[^\s<>]+)/g;
  const processedHtml = html.replace(urlRegex, (url) =>
    url.replace(/.{20}/g, "$&<wbr>"),
  );
  return {
    dangerouslySetInnerHTML: {
      __html: sanitizeHtml(processedHtml, {
        allowedAttributes: {
          "*": [
            "class",
            "data-legal",
            "disclosure",
            "href",
            "className",
            "target",
            "rel",
          ],
        },
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(["wbr"]),
      }),
    },
  };
};

export default setHtml;
